<template>
  <div id="custom_template">

    <div id="header">
      <img class="make-goodest" src="./assets/images/logo.gif" />
    </div>

    <!---REG METHODS BLOCK -->
    <div id="rms" class="rms" v-if="registration_methods.length>0">
      <registration-method
        v-for="(registration_method,index) in registration_methods"
        :key="index"
        v-on:changeSelected="changeSelected"
        v-on:changeSelectedTOS="changeSelectedTOS"
        v-on:emitRegistrationMethodData="emitRegistrationMethodData"
        :index="index"
        :selected="doc.selected_rm"
        :selected_tos="doc.selected_tos"
        :registration_method="registration_method" />
    </div>
      <!-- END REG METHOD BLOCK -->

        <div>
          <p class="text-center text-14 mb-0 tosText">By clicking Accept you agree to the
            <span @click="changeSelectedTOS()" class="text-link"><b>Terms and Conditions</b></span>
          </p>
          <div class="terms-of-service text-left pt-20"  style="display: none;">
            <div >
              <img class="tos-logo" src="./assets/images/logo_2.png" />
            </div>
            <div v-html="terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="changeSelectedTOS()">CLOSE</button></div>
          </div>
        </div>
  </div>
</template>

<script>
import $ from 'jquery'
import RegistrationMethod from '@/components/custom/hcny/CustomHCNYMethods'

export default {
  name: 'custom_template',
  props: [
    'portal',
    'connection_data'
  ],
  components: {
    'registration-method': RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    'doc.selected_rm': function(){
      this.doc.selected_tos = null;
    },
  },
  data(){
    return{
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: '8772822519',
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<b>The Harvard Club of New York City<br>Wireless Networking<br>Terms & Conditions of Use</b><br></br>The Harvard Club of New York City offers the WiFi wireless Internet service (the “Service”) according to this WiFi Wireless Networking Acceptable Use Policy (the “Policy”) as a free service to Members and Guests for the duration of their visit to the Club. We do not guarantee the Service or specific rates of speed. We also have no control over information obtained through the Internet and cannot be held responsible for its content or accuracy. Use of the service is subject to the user’s own risk. We reserve the right to remove, block, filter, or restrict by any other means any material that, in our sole discretion, may be illegal, may subject us to liability, or may violate this Policy. We may cooperate with legal authorities and/or third parties in the investigation of any suspected or alleged crime or civil wrong. Violations of this Policy may result in the suspension or termination of access to the Service or other resources, or other actions as detailed below.<br></br><b>Responsibilities of Service Users:</b><br>Users are responsible for ensuring they are running up-to-date anti-virus software on their wireless devices. Users must be aware that, as they connect their devices to the Internet through the Service, they expose their devices to: worms, viruses, Trojan horses, denial-of-service attacks, intrusions, packet-sniffing, and other abuses by third-parties. Users must respect all copyrights. Downloading or sharing copyrighted materials is strictly prohibited. The running of programs, services, systems, processes, or servers by a single user or group of users that may substantially degrade network performance or accessibility will not be allowed. Accessing another person's computer, computer account, files, or data without permission is prohibited. Attempting to circumvent or subvert system or network security measures is prohibited. Creating or running programs that are designed to identify security loopholes, to decrypt intentionally secured data, or to gain unauthorized access to any system is prohibited. Using any means to decode or otherwise obtain restricted passwords or access control information is prohibited.Forging the identity of a user or machine in an electronic communication is prohibited. Saturating network or computer resources to the exclusion of another's use, for example, by overloading the network with traffic such as emails or legitimate (file backup or archive) or malicious (denial of service attack) activity,is prohibited. Users understand that wireless Internet access is inherently not secure, and users should adopt appropriate security measures when using the Service. We highly discourage users from conducting confidential transactions (such as online banking, credit card transactions, etc.) over any wireless network, including this Service. Users are responsible for the security of their own devices.<br></br><b>Limitations of Wireless Network Access:</b><br>We are not liable for any damage, undesired resource usage, or detrimental effects that may occur to a user's device and/or software while the user’s device is attached to the Service. The user is responsible for any actions taken from his or her device, whether intentional or unintentional, that damage or otherwise affect other devices or users of the Service. The user hereby releases the Harvard Club of New York City from liability for any loss, damage, security infringement, or injury which the user may sustain as a result of being allowed access to the Service. The user agrees to be solely responsible for any such loss, infringement, damage, or injury.<br></br><b>Separation of Terms</b><br>Each of the terms, conditions and policies in this Agreement stand alone. Should any be found by a court to be unenforceable, the remainder of the Agreement remains in full force and effect.<br></br><b>Waiver</b><br>Failure by the Harvard Club of New York City to exercise any of its rights shall not be a waiver or forfeiture of such rights.<br></br><b>Indemnification</b><br>You indemnify The Harvard Club of New York City and hold it harmless from any loss, claim or damage arising out of your use of the the Service.<br></br><b><i>All users of this Service have agreed to the terms of this Policy by clicking the ACCEPT button.</b></i>`,
    }
  },
  filters: {
    phone: function (value) {
      if (!value) return '';
      value = value.toString();
      return '(' + value.substr(0,3) + ') ' + value.substr(3,3) + '-' + value.substr(6,4);
    }
  },
  mounted(){
    if(this.portal.template.support_phone){
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();
  },
  methods: {
    generateRegistrationMethods:function(){
      for(var i in this.portal.registration_methods){
        var rm = this.portal.registration_methods[i];
        for(var c in rm.rate_plans){
          var rateplan = rm.rate_plans[c];
          var plan = {
            name: rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: 'rateplan',
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };

          this.registration_methods.push(plan);
        }
      }
      if(this.portal.access_codes.length>0){
        plan = {
          name: 'Access Code',
          type: 'accesscode',
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if( this.registration_methods.length == 1 ){
        this.doc.selected_rm = 0;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function(index){
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function(){
      $('.terms-of-service').toggle()
    },
    // Send registration method details back to parent
    emitRegistrationMethodData:function(emitted){
      // Check the template for v-on:emitRegistrationMethodData
      this.$emit('emitRegistrationMethodData',emitted);
    },

  }
}
</script>

<style>
#custom_template {
  margin-top: -30px;
}
#header {
  background:  #ac292e;
  padding: 30px 0;
}

.make-gooder {
  width:  75%;
  margin: 0 auto;
}

.make-goodest {
    max-width: 80%;
    margin: auto;
    padding-top: 30px;
}

.rm .btn.rounded {
  margin-top: 10px;
}

.terms-of-service {
  background-color: white;
  width: 75%;
  max-height: 20rem;
  border: 1px solid #6D3E34;
  display: inline-block;
  overflow-x: auto;
  padding: 2rem;
  margin: 2rem;
}

.btn-close {
  width: 50%;
  margin: auto;
}

.text-link {
  cursor: pointer;
}

.tos-logo {
  width: auto;
  height: 6rem;
  margin-bottom: 1rem;
}

</style>
